import { render, staticRenderFns } from "./HistoricField.vue?vue&type=template&id=67ef2518&scoped=true"
import script from "./HistoricField.vue?vue&type=script&lang=js"
export * from "./HistoricField.vue?vue&type=script&lang=js"
import style0 from "./HistoricField.vue?vue&type=style&index=0&id=67ef2518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef2518",
  null
  
)

export default component.exports